// extracted by mini-css-extract-plugin
module.exports = {"ModalStyle":"modaldrag_ModalStyle__1RBN4","titleCenterModal":"modaldrag_titleCenterModal__afiW1","ModalStyleFooterPosition":"modaldrag_ModalStyleFooterPosition__3e3u4"};